import styled, { css } from "styled-components";
import Button from "@mui/material/Button";
import { COLORS } from "../../styles/constants.style";
import { buttonTypography } from "../typography/MuiTypography.style";
const buttonStyles = css`
  padding: 16px 32px;
  border-radius: 8px;
  height: 52px;
  box-sizing: border-box;
  text-transform: capitalize;
  line-height: 19.8px;
  ${buttonTypography}
`;

const primaryStyles = css`
  ${buttonStyles}
  background: ${COLORS.primary_light_blue};
  color: ${COLORS.cirrus_white};

  &:hover,
  &:focus-visible {
    background: ${COLORS.primary_dark_blue7};
  }

  &:active {
    background: ${COLORS.primary_dark_blue9};
  }

  &:disabled {
    background: ${COLORS.primary_light_blue1};
    color: ${COLORS.primary_light_blue5};
  }
`;

const secondaryStyles = css`
  ${buttonStyles}
  background: ${COLORS.cirrus_black2};
  border: 1px solid ${COLORS.primary_light_blue};
  color: ${COLORS.primary_light_blue};
  box-shadow: 0 0 0 0 ${COLORS.primary_light_blue};

  &:hover:not(:disabled):not(.disabled),
  &:focus-visible {
    border: 1px solid ${COLORS.primary_dark_blue7};
    outline: 1px solid ${COLORS.primary_dark_blue7};
    color: ${COLORS.primary_dark_blue7};
    box-shadow: 0 0 0 1px ${COLORS.primary_dark_blue7};
  }

  &:not(:disabled):not(.disabled):active {
    background: ${COLORS.primary_light_blue1};
    border: 1px solid ${COLORS.primary_dark_blue9};
    color: ${COLORS.primary_dark_blue9};
  }

  &:disabled {
    background: ${COLORS.cirrus_black1};
    color: ${COLORS.cirrus_black6};
    border: 1px solid ${COLORS.cirrus_black3};
  }
`;

const tertiaryStyles = css`
  ${buttonStyles}
  padding: 0px;
  background: none;
  color: ${COLORS.primary_light_blue};

  &:hover:not(:disabled):not(.disabled),
  &:focus-visible {
    color: ${COLORS.primary_dark_blue7};
    text-decoration: underline;
  }

  &:not(:disabled):not(.disabled):active {
    color: ${COLORS.primary_dark_blue9};
    text-decoration: underline;
  }

  svg {
    color: inherit;
  }

  &:disabled {
    color: ${COLORS.primary_light_blue5};

    svg {
      color: ${COLORS.primary_light_blue5};
    }
  }
`;

export const ButtonWrapper = styled(Button)`
  &.btn-primary {
    ${primaryStyles}
  }

  &.btn-secondary {
    ${secondaryStyles}
  }

  &.btn-tertiary {
    ${tertiaryStyles}
  }
`;
